import React from 'react';

import { Controller } from 'react-hook-form';

import {
    DESCRIPTION_REQUIRED,
    PLACEHOLDER_TEXT,
} from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/components/Description/Description.consts';
import {
    MAX_CHAR_NAME_VALIDATION,
    MIN_CHAR_NAME_VALIDATION,
    NAME_IS_REQUIRED,
} from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/components/TemplateName/TemplateName.consts';
import { ReportTagsSelectWithCreate } from 'components/Dashboards/Reporting/_common/ReportTagsSelectWithCreate/ReportTagsSelectWithCreate';
import { Alert } from 'components/DesignSystem/Alert';
import { TextInput } from 'components/DesignSystem/TextInput';
import { CustomizedFormErrorMessage } from 'components/common';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/EditReportTemplateModal/EditReportTemplateForm/EditReportTemplateForm.module.scss';
import { UseEditReportTemplateModalLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/EditReportTemplateModal/EditReportTemplateModal.Logic';

interface Props {
    logic: UseEditReportTemplateModalLogic['logic'];
}

const MAX_DESCRIPTION_CHARS = 250;

export const EditReportTemplateForm = ({ logic }: Props) => {
    const { setValue, control, register, formState, watch } = logic.form;

    return (
        <form className={classes.formContainer}>
            <div className={classes.nameSection}>
                <label htmlFor={'templateName'}>Template name:</label>
                <Controller
                    render={({ field }) => {
                        return (
                            <TextInput
                                {...field}
                                placeholder={'New Template name...'}
                                maxLength={50}
                                onClear={() => {
                                    setValue('templateName', '');
                                }}
                            />
                        );
                    }}
                    name={'templateName'}
                    control={control}
                    rules={{
                        required: NAME_IS_REQUIRED,
                        minLength: { value: 2, message: MIN_CHAR_NAME_VALIDATION },
                        maxLength: { value: 50, message: MAX_CHAR_NAME_VALIDATION },
                    }}
                />
                {formState.errors.templateName && (
                    <CustomizedFormErrorMessage text={formState.errors.templateName.message} />
                )}
            </div>

            <div className={classes.descriptionSection}>
                <div className={classes.descriptionTitle}>
                    <label htmlFor={'templateDescription'}>Description:</label>
                    <div>
                        <p>{`${watch('templateDescription')?.length ?? 0}/${MAX_DESCRIPTION_CHARS}`}</p>
                    </div>
                </div>
                <textarea
                    id={'templateDescription'}
                    className={classes.descriptionTextarea}
                    {...register('templateDescription', { required: DESCRIPTION_REQUIRED })}
                    rows={4}
                    maxLength={MAX_DESCRIPTION_CHARS}
                    placeholder={PLACEHOLDER_TEXT}
                />
                {formState.errors.templateDescription && (
                    <CustomizedFormErrorMessage text={formState.errors.templateDescription.message} />
                )}
            </div>

            <div className={classes.tagsSection}>
                <label htmlFor={'selectedTags'}>Tags:</label>
                <ReportTagsSelectWithCreate control={control} handleChange={logic.handleTagsChange} />
                <Alert severity={'info'}>
                    Reports that are created using this template will automatically have the selected tags associated
                    with them.
                </Alert>
            </div>
        </form>
    );
};
